import React from 'react'
import Navigation from '../../components/Navigations/Navigation';
import Footer from '../../components/Footer/Footer';
import Contact from '../../components/Contact/Contact';
import OurLocation from '../../components/OurLocation/OurLocation';


const ContactPage = () => {
  return (
    <div>
      <div> <Navigation /></div>
      <div><Contact /> </div>
      <div>
    <OurLocation />
      </div>
      {/* <div><Footer /></div> */}
      
    </div>
  )
}

export default ContactPage;
